import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import ViewTabs from '../../../organisms/AdvisorView/components/AdvisorViewTabs'
import { usePolicies } from '../../../../hooks'
import GeneralTab from './GeneralTab'
import ClientsTab from './ClientsTab'
import SecurityTab from './SecurityTab'
import { useAdvisorUserDetails } from './AdvisorUserFormContext'

const useStyles = makeStyles((theme) => ({
  clientDetailTabs: {},
  viewTabs: {
  }
}))

const tabOptions = {
  general: {
    value: 'general',
    label: 'General Info'
  },
  households: {
    value: 'households',
    label: 'Households'
  },
  security: {
    value: 'security',
    label: 'Security'
  }
}

const useTabOptions = () => {
  const policies = usePolicies()
  return useMemo(() => {
    const result = {}
    if (policies.admin_view_advisor_users) {
      result.general = tabOptions.general
    }
    if (policies.admin_view_advisor_users) {
      result.households = tabOptions.households
    }
    if (policies.admin_view_advisor_users) {
      result.security = tabOptions.security
    }
    return result
  }, [policies])
}

function AdvisorUserDetailTabs ({ onTabChange, disabled }) {
  const classes = useStyles()
  const { cancelEdit } = useAdvisorUserDetails()
  const tabs = useTabOptions()

  return (
    <div className={classes.clientDetailTabs}>
      <ViewTabs.Group tabOptions={tabs} onChange={cancelEdit}>
        <div className={classes.viewTabs}>
          <ViewTabs.Links
            disabled={disabled}
            tabsKey='admin_advsior_user_details'
          />
        </div>
        {tabs.general ? (
          <ViewTabs.Tab value='general'>
            <GeneralTab />
          </ViewTabs.Tab>
        ) : null}
        {tabs.households ? (
          <ViewTabs.Tab value='households'>
            <ClientsTab />
          </ViewTabs.Tab>
        ) : null}
        {tabs.security ? (
          <ViewTabs.Tab value='security'>
            <SecurityTab />
          </ViewTabs.Tab>
        ) : null}
      </ViewTabs.Group>
    </div>
  )
}

AdvisorUserDetailTabs.propTypes = {
  onTabChange: PropTypes.func,
  disabled: PropTypes.bool
}

AdvisorUserDetailTabs.defaultProps = {
  onTabChange: () => {},
  disabled: false
}

export default AdvisorUserDetailTabs
